

































import { usePagination } from '@/bundles/BaseTable/composables/usePagination.ts';
import { useSession } from '@/bundles/Session/composables/useSession.ts';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { defineComponent, ref, watch } from '@vue/composition-api';
import SessionListTable from '@/bundles/Session/components/SessionListTable.vue';
import { debounce } from '@/bundles/App/helpers';

export default defineComponent({
  name: 'Session',

  components: {
    SessionListTable,
  },

  setup: function () {
    const { fetch, session, total, pending } = useSession();
    const { tableOptions, pageOffset } = usePagination({ sortBy: ['created'], sortDesc: [true] });
    const activeFilter = ref<boolean|null>(true);
    const keywordFilter = ref<string>('');
    const debouncedSearch = debounce(() => {
      if (tableOptions.value.page !== 1) {
        tableOptions.value.page = 1;
      } else {
        fetchWrapper();
      }
    }, 500);
    const activeItems = [
      { text: 'Active', value: true },
      { text: 'Inactive', value: false },
      { text: 'All', value: null },
    ];

    async function fetchWrapper() {
      const wrapper = document.querySelector('.base-table-wrapper .v-data-table__wrapper')
      if (wrapper) {
        wrapper.scrollTop = 0
      }
      const params: any[] = [
        {
          name: 'skip',
          value: pageOffset.value,
        },
        {
          name: 'take',
          value: tableOptions.value.itemsPerPage,
        },
        {
          name: 'type',
          value: 0,
        }
      ]

      if (activeFilter.value !== null) {
        params.push({
          name: 'active',
          value: activeFilter.value,
        });
      }

      if (keywordFilter.value) {
        params.push({
          name: 'keyword',
          value: keywordFilter.value,
        });
      }

      if (tableOptions.value.sortBy?.length) {
        params.push({
          name: 'sort_by',
          value: tableOptions.value.sortBy[0],
        });
      }

      if (tableOptions.value.sortDesc?.length) {
        params.push({
          name: 'sort_desc',
          value: true,
        });
      }

      await fetch(params);
    }
    watch(() => tableOptions, () => fetchWrapper(), { deep: true, immediate: true });
    watch(() => activeFilter, () => {
      if (tableOptions.value.page !== 1) {
        tableOptions.value.page = 1;
      } else {
        fetchWrapper();
      }
    }, { deep: true });
    function optionsChangeEventHandler(options: ITableOptions) {
      tableOptions.value = { ...options };
    }

    return {
      session,
      tableOptions,
      total,
      pending,
      activeFilter,
      activeItems,
      keywordFilter,
      debouncedSearch,
      optionsChangeEventHandler,
      fetchWrapper,
    };
  },
});
